export default __webpack_public_path__ + "static/media/logo-gray.9cb7c0f6.svg";